import { orderBy } from 'lodash';

import type { BrandBrief } from './types';

export const sortBrandBriefs = (items: BrandBrief[]): BrandBrief[] =>
  orderBy(items, ['updatedAt', 'name', 'id'], ['desc', 'asc', 'asc']);

export const BRAND_BRIEF_TYPE = {
  productDescription: 'product_description',
  companyDescription: 'company_description',
  oneLiner: 'one_liner',
  elevatorPitch: 'elevator_pitch',
  whoWeAre: 'who_we_are',
  other: 'other',
} as const;
export type BrandBriefType = (typeof BRAND_BRIEF_TYPE)[keyof typeof BRAND_BRIEF_TYPE];

interface BrandBriefTypeProps {
  label: string;
  titlePlaceholder?: string;
  bodyPlaceholder: string;
}

const BRAND_BRIEF_TYPE_PROPS: Record<string, BrandBriefTypeProps> = {
  [BRAND_BRIEF_TYPE.productDescription]: {
    label: 'Product Description',
    titlePlaceholder: 'The name of the product associated with this asset',
    bodyPlaceholder:
      'Provide a detailed description of the product. This should highlight key features, benefits, and any other relevant information.',
  },
  [BRAND_BRIEF_TYPE.companyDescription]: {
    label: 'Company Description',
    titlePlaceholder: 'The name of the company associated with this asset',
    bodyPlaceholder: 'Provide a detailed description of the company.',
  },
  [BRAND_BRIEF_TYPE.oneLiner]: {
    label: 'One-liner',
    bodyPlaceholder: 'Paste your one-liner here',
  },
  [BRAND_BRIEF_TYPE.elevatorPitch]: {
    label: 'Elevator Pitch',
    bodyPlaceholder: 'Paste your elevator pitch here',
  },
  [BRAND_BRIEF_TYPE.whoWeAre]: {
    label: 'Who We Are',
    bodyPlaceholder: 'Paste your "Who We Are" here',
  },
  [BRAND_BRIEF_TYPE.other]: {
    label: 'Other',
    bodyPlaceholder: 'Provide content for for this asset',
  },
};

export const getBrandBriefTypeLabel = (briefType: BrandBriefType): string =>
  BRAND_BRIEF_TYPE_PROPS[briefType]?.label;

export const brandBriefTypeHasTitle = (briefType: BrandBriefType): boolean => {
  const list = [
    BRAND_BRIEF_TYPE.productDescription,
    BRAND_BRIEF_TYPE.companyDescription,
  ] as BrandBriefType[];
  return list.includes(briefType);
};

export const getBrandBriefTypeTitlePlaceholder = (briefType: BrandBriefType): string | undefined =>
  BRAND_BRIEF_TYPE_PROPS[briefType]?.titlePlaceholder;

export const getBrandBriefTypeBodyPlaceholder = (briefType: BrandBriefType): string =>
  BRAND_BRIEF_TYPE_PROPS[briefType]?.bodyPlaceholder;
